module.exports = __webpack_public_path__ + "static/media/line_sdf.vertex.29b4513b.glsl";